/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {NgModule} from '@angular/core';
import {Platform} from './platform';
export class PlatformModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  providers: [Platform]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function PlatformModule_tsickle_Closure_declarations() {
/** @type {?} */
PlatformModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PlatformModule.ctorParameters;
}



export {Platform} from './platform';
export {getSupportedInputTypes} from './features';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
